module.exports = __webpack_public_path__ + "static/media/preview-verbal.a2348e26.svg";